export default class Overview {
    constructor(elm) {
        this.elm = elm;
        this.alias = this.elm.dataset.overviewAlias;
        this.tags = this.elm.dataset.overviewTags;
        this.themeTags = this.elm.dataset.overviewThemeTags;
        this.order = this.elm.dataset.overviewOrder;
        this.annoncer = this.elm.dataset.overviewAnnoncer;
        this.exclude = this.elm.dataset.overviewExclude;

        var loadMore = this.elm.querySelector('[data-overview-load-more]');
        if (!loadMore) {
            return;
        }

        loadMore.addEventListener('click', e => {
            e.preventDefault();
            this.fetch()
                .then(data => {
                    this.elm.querySelector('[data-overview-element]').insertAdjacentHTML('beforeend', data.Html);
                    this.elm.dataset.overviewIndex = data.Index;

                    if (!data.MoreToLoad)
                        this.elm.querySelector('[data-overview-load-more]').style.display = 'none';

                    window.gpt.reload();

                    loadMore.dispatchEvent(new Event('btn:load:done'));
                })
                .catch(error => {
                    // TODO DO SOMETHINE WITH THE ERROR - IT`S LOG IN UMBRACO LOGGER
                    console.error(error);
                });
        });
    }

    fetch() {
        const _ = this;
        return new Promise((resolve, reject) => {
            if (_.elm.dataset.overviewCulture === '' || _.elm.dataset.overviewIndex === '') {
                reject();
            } else {
                var tagsQuery = _.tags ? `&tags=${_.tags}` : '';
                var themeTagsQuery = _.themeTags ? `&themeTags=${_.themeTags}` : '';
                var order = _.order ? `&orderField=${_.order}` : '';
                var annoncer = _.annoncer ? `&annoncer=${_.annoncer}` : '';
                var exclude = _.exclude ? `&exclude=${_.exclude}` : '';
                fetch(`/umbraco/api/overview/get?culture=${_.elm.dataset.overviewCulture}&alias=${_.alias}&skip=${_.elm.dataset.overviewIndex}&columns=${_.elm.dataset.overviewColumns}${tagsQuery}${themeTagsQuery}${order}${exclude}${annoncer}`, {
                    method: 'GET',
                    cache: 'no-cache',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then(response => response.json())
                    .then(data => data.Success ? resolve(data) : reject(data))
                    .catch(data => {
                        throw new Error(data);
                    });
            }
        });
    }
}
